<template>
  <div class="cotainer card-item">
    <div class="title-box">
      <span class="title-text">思政实践基地</span>
    </div>
    <div class="title-boxs">
      <!-- v-if="oldInfos && oldInfos.id  && !isEdit" -->
      <span class="btn-action-group">
        <a-button type="primary" @click="addBase" class="btn-action"
          >新增基地</a-button
        >
        <!-- <a-button type="primary" @click="addBaseActive" class="btn-action"
          >新增活动</a-button
        > -->
        <!-- <a-button @click="importsj(1)" class="btn-action" style="width:150px;">思政实践基地导入</a-button>
         <a-button @click="importsj(2)" class="btn-action" style="width:150px;">基地实践活动导入</a-button> -->
        <a-button class="btn-action" danger type="text" @click="batchDelete">
          批量移除</a-button
        >
      </span>
    </div>
    <!-- :row-selection="rowSelection" -->
    <!-- -->
    <div class="cotainerfottter">
      <a-table
        style="text-align: center"
        :locale="{ emptyText: '暂无数据' }"
        :columns="columns"
        :data-source="dataList"
        :loading="loading"
        :pagination="pagination"
        :bordered="true"
        rowKey="id"
        :scroll="{ y: 290 }"
        :row-selection="rowSelection"
        @change="handleTableChange"
      >
        <template slot="sequenceNumber" slot-scope="text, record, index">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </template>
        <!-- <template slot="sex" slot-scope="text">
          <span v-if="text == '1'">男</span>
          <span v-else>女</span>
        </template>
        <template slot="izResponse" slot-scope="text">
          <span v-if="text == '1'">是</span>
          <span v-else>否</span>
        </template> -->
        <!-- <template
          style="width: 100px"
          slot="partNum"
          slot-scope="text,record"
        >
          <tr
            v-for="(item, index) in record.practiceBaseList"
            :key="index"
            :style="
              index + 1 == record.practiceBaseList.length
                ? ''
                : 'border-bottom: 1px solid #e8e8e8;'
            "
            class="table-tr"
          >
            <div class="table-content" :title="item.acquireYear">
              <span>{{ item.acquireYear }}</span>
            </div>
          </tr>
          <span v-if="record.practiceBaseList.length == 0">-</span>
        </template> -->
        <!-- <template
          style="width: 100px"
          slot="capitalSource"
          slot-scope="text, record"
        >
          <tr
            v-for="(item, index) in record.practiceBaseList"
            :key="index"
            :style="
              index + 1 == record.practiceBaseList.length
                ? ''
                : 'border-bottom: 1px solid #e8e8e8;'
            "
            class="table-tr"
          >
            <div class="table-content" :title="item.peopleNum">
              <span>{{ item.peopleNum }}</span>
            </div>
          </tr>
          <span v-if="record.practiceBaseList.length == 0">-</span>
        </template> -->
        <span
          class="flex flex-around"
          slot="action"
          slot-scope="record"
          style="margin: 0 10px"
        >
          <!-- v-if="oldInfos && oldInfos.id && !isEdit" -->
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="editInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img42.png" alt="" />
            <span>编辑</span>
          </div>
          <!-- v-if="oldInfos && oldInfos.id && !isEdit" -->
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="deleteInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img43.png" alt="" />
            <span>移除</span>
          </div>
        </span>
      </a-table>
    </div>
    <a-modal
      title="您确定移除吗"
      :visible="showDeleteModel"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="showDeleteModel = false"
    >
      <p>您确定要移除思政实践基地该条的数据吗?</p>
    </a-modal>
    <!-- 添加基地 -->
    <AddBase ref="addBase" @addBase="addGaincz"></AddBase>
    <!-- 添加活动 -->
    <AddBaseActive ref="addBaseActive" @addGain="addGain"></AddBaseActive>

    <data-import ref="dataImport" @refreshData="addGain"></data-import>
  </div>
</template>
    
<script>
import { getAction, postAction, putAction, deleteAction } from "@/api/index";
import dataImport from "@/components/common/dataImport.vue";

import AddBase from "./addBase.vue";
import AddBaseActive from "./addBaseActive.vue";
const columns = [
  {
    title: "序号",
    dataIndex: "sequenceNumber",
    id: "sequenceNumber",
    align: "center",
    scopedSlots: { customRender: "sequenceNumber" },
    width: 70,
  },
  {
    title: "基地名称",
    dataIndex: "baseName",
    id: "baseName",
    align: "center",
    width: 80,
  },
  {
    title: "基地形式",
    // dataIndex: "baseForm_dictText",
    // id: "baseForm_dictText",
    dataIndex: "baseForm",
    id: "baseForm",
    align: "center",
    width: 80,
  },
  {
    title: "基地类别",
    dataIndex: "baseType",
    id: "baseType",
    align: "center",
    width: 80,
  },
  {
    title: "加入时间",
    dataIndex: "cooperativeTime",
    id: "cooperativeTime",
    align: "center",
    width: 80,
  },
  {
    title: "活动主题",
    dataIndex: "subject",
    id: "subject",
    align: "center",
    width: 100,
  },
  // {
  // 	title: "支出项目",
  // 	dataIndex: "createTime",
  // 	id: "createTime",
  // 	align: "center",
  // 	width: 150,
  // 	scopedSlots: { customRender: "capitalSource" },
  // },
  // {
  //   title: "剩余金额",
  //   dataIndex: "surplusAmount",
  //   id: "surplusAmount",
  //   align: "center",
  //   width: 150,
  // },
  {
    title: "活动年份",
    dataIndex: "acquireYear",
    id: "acquireYear",
    // scopedSlots: { customRender: "partNum" },
    align: "center",
    width: 80,
  },
  {
    title: "参与人次",
    dataIndex: "peopleNum",
    id: "peopleNum",
    // scopedSlots: { customRender: "capitalSource" },
    align: "center",
    width: 80,
  },
  {
    title: "操作",
    id: "action",
    align: "center",
    width: 184,
    scopedSlots: { customRender: "action" },
  },
];
export default {
  data() {
    return {
      dataList: [],
      loading: false,
      showDeleteModel: false,
      deteleId: "",
      pagination: {
        total: 0,
        current: 1,
        pageSize: 5,
      },
      columns: columns,
      selectedRowKeys: [],
      isEdit: false,
    };
  },
  props: {
    oldInfos: {
      type: Object,
    },
    isbj: {
      type: Boolean,
      defalt: true,
    },
  },
  components: {
    AddBase,
    AddBaseActive,
    dataImport,
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      };
    },
  },
  watch: {
    "oldInfos.baselist": {
      handler(newValue, oldValue) {
        // console.log(newValue, "9999999999999999");
        if (newValue != null) {
          if (
            this.$parent.editInfo &&
            this.$parent.editInfo?.type == "preview"
          ) {
            this.isEdit = true;
          }
          this.addGain();
        }
        // console.log(newValue, "8989898989");
      },
      deep: true,
    },
    isbj: {
      handler(newValue, oldValue) {
        // console.log(newValue,'我是')
        this.isEdit = newValue;
      },
      immediate: true,
    },
  },
  mounted() {
    this.isEdit =
      this.$parent.editInfo && this.$parent.editInfo.type == "preview";
    this.getData();
  },
  methods: {
    importsj(num) {
      if (num == "1") {
        this.$refs.dataImport.init(
          "cooperativebase",
          this.oldInfos,
          "思政实践基地导入"
        );
      } else {
        this.$refs.dataImport.init(
          "szbaseActivity",
          this.oldInfos,
          "基地实践活动导入"
        );
      }
    },
    handleOk() {
      this.$message.success("移除成功");
      this.showDeleteModel = false;
      this.oldInfos.baselist = this.oldInfos.baselist.filter(
        (item) => item.id != this.deteleId
      );
      sessionStorage.setItem("gzs1", JSON.stringify(this.oldInfos));
      this.getData();
      // deleteAction("/lxbase/lxApplyCooperativeBase/delete", {
      //   id: this.deteleId,
      // }).then((res) => {
      //   if (res.code == 200) {
      //     this.$message.success("移除成功");
      //     this.showDeleteModel = false;
      //     this.getData();
      //   } else {
      //     this.$message.error(res.message);
      //   }
      // });
    },
    addBase() {
      this.$refs.addBase.init("add", this.oldInfos);
    },
    addBaseActive() {
      this.$refs.addBaseActive.init("add", this.oldInfos);
    },
    addGaincz(sj) {
      if (sj.type == "add") {
        this.pagination.current = 1;
        this.oldInfos.baselist.unshift({
          ...sj.record,
          id: sj.record.baseName + this.oldInfos.baselist.length,
        });
      } else {
        let index = this.oldInfos.baselist.findIndex(
          (item) => item.id === sj.record.id
        );
        if (index !== -1) {
          // 如果找到相同的 id，替换该对象
          this.oldInfos.baselist[index] = sj.record;
        }
      }
      sessionStorage.setItem("gzs1", JSON.stringify(this.oldInfos));
      this.getData();
    },
    addGain() {
      //this.pagination.current = 1;
      this.getData();
    },
    getData() {
      if (
        this.oldInfos &&
        this.oldInfos.baselist &&
        this.oldInfos.baselist.length > 0
      ) {
        this.pagination.total = this.oldInfos.baselist.length;
        const startIndex =
          (this.pagination.current - 1) * this.pagination.pageSize;
        const endIndex = startIndex + this.pagination.pageSize;
        let formatList = this.oldInfos.baselist.slice(startIndex, endIndex);
        if (formatList.length == 0 && this.pagination.current > 1) {
          this.pagination.current = this.pagination.current - 1;
          const startIndex =
            (this.pagination.current - 1) * this.pagination.pageSize;
          const endIndex = startIndex + this.pagination.pageSize;
          formatList = this.oldInfos.baselist.slice(startIndex, endIndex);
        }
        this.dataList = formatList;
      } else {
        this.dataList = [];
        this.pagination.total = 0;
        this.pagination.current = 1;
      }

      // this.loading = true;
      // let data = {
      //   applyType: 1,
      //   pageNo: this.pagination.current,
      //   pageSize: this.pagination.pageSize,
      //   applyId: this.oldInfos?.id,
      // };
      // getAction("/lxbase/lxApplyCooperativeBase/list", data).then((res) => {
      //   if (res.code === 200) {
      //     let data = res.result.records;
      //     if (data) {
      //       this.dataList = data;
      //       this.pagination.total = res.result.total;
      //     }
      //   }
      //   this.loading = false;
      // });
    },
    deleteInfo(row) {
      this.showDeleteModel = true;
      this.deteleId = row.id;
    },
    editInfo(row) {
      this.$refs.addBase.init("edit", row);
      // this.$refs.addBaseActive.init("edit", row);
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getData();
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    batchDelete() {
      // let applyType = 1;
      // if (this.$route.name === "szStudio") {
      //   applyType = 1;
      // } else if (this.$route.name === "educationalBrand") {
      //   applyType = 2;
      // } else {
      //   applyType = 3;
      // }
      if (this.selectedRowKeys.length == "0") {
        this.$message.warning("请选择要批量移除的实践基地");
      } else {
        //this.pagination.current = 1;
        // console.log(this.selectedRowKeys);
        this.oldInfos.baselist = this.oldInfos.baselist.filter(
          (item) => !this.selectedRowKeys.includes(item.id)
        );
        sessionStorage.setItem("gzs1", JSON.stringify(this.oldInfos));
        this.getData();
        this.selectedRowKeys = [];
        // let params = {
        //   ids: this.selectedRowKeys.toString(),
        // };
        // deleteAction("/lxbase/lxApplyCooperativeBase/deleteBatch", params).then(
        //   (res) => {
        //     if (res.code == 200) {
        //       this.$message.success("批量移除成功");
        //       this.pagination.current =1;
        //       this.getData();
        //       this.selectedRowKeys = [];
        //       this.$forceUpdate();
        //     } else {
        //       this.$message.error(res.message);
        //     }
        //   }
        // );
      }
    },
  },
};
</script>
    
<style scoped="scoped" lang="scss">
.cotainer {
  &.card-item {
    background: #ffffff;
    box-shadow: 1px 2px 14px 7px rgba(180, 180, 180, 0.11);
    padding: 37px 20px;
    box-sizing: border-box;
    margin-bottom: 24px;
    .title-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 700;
      border-bottom: 1px solid #d9d9d9;
      .title-text {
        color: #2155b5;
        font-size: 20px;
        font-weight: bold;
        height: 40px;
        line-height: 40px;
        border-bottom: 3px solid #2155b5;
        padding: 0px 4px;
      }
    }
    .title-boxs {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-bottom: 12px;
      font-size: 20px;
    }
    .btn-action {
      width: 100px;
      height: 30px;
      border-radius: 6px;
      font-weight: 400;
      cursor: pointer;
      line-height: 30px;
      margin-right: 10px;
      text-align: center;
    }
  }
  .cotainerhead {
    margin: 20px 0px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .add-btn {
      width: 100px;
      height: 30px;
      background: #2155b5;
      border-radius: 6px;
      font-weight: 400;
      color: #fff;
      cursor: pointer;
      line-height: 30px;
      margin-right: 10px;
      text-align: center;
    }
  }
}
.img-box {
  width: 18px;
  height: 18px;
  margin-right: 9px;
}
.img-box-preview {
  width: 21px;
  height: 21px;
  margin-right: 9px;
}
.table-content {
  margin: 0 auto;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
}
.table-tr {
  width: 100%;
  display: inline-block;
  text-align: center;
  margin: 0 auto;
  // border-bottom: 1px solid #e8e8e8;
}
/deep/.ant-table-tbody > tr > td:nth-child(6),
/deep/.ant-table-tbody > tr > td:nth-child(7) {
  padding: 0 !important;
  // overflow-wrap: break-word;
}
</style>